export const PoemFiftyFiftyFiftyFifty = () => {
    return (
        <div id="043" className="">
            <p>half of everything is just waiting for things to get</p>
            <p>into the right position,</p>
            <p>
                most of the wait goes by in a flash and what's left feels like
                eternity,
            </p>
            <p>half of any act of making contact is just</p>
            <p>choosing to reply to the other person,</p>
            <p>these words are our surrogates, our stand-ins,</p>
            <p>
                half of the lies spoken out there turn out to be truths in
                disguise,
            </p>
            <p>half of myself is probably taken from somewhere else,</p>
            <p>half of the present is just the past,</p>
            <p>
                a good chunk of the things that make my skin crawl are probably
                just
            </p>
            <p>parts of myself reflected back at me,</p>
            <p>half-worried,</p>
            <p>in every interaction, i think</p>
            <p>half of the time is spent looking elsewhere.</p>
            <p>it doesn't look like there's anything missing, but rather</p>
            <p>that's just the natural order of the world,</p>
            <p>everything intertwined,</p>
            <p>everything split down the middle,</p>
            <p>
                one of the halves leaves its place of birth and slowly but
                surely
            </p>
            <p>another one comes in its place</p>
            <p>and</p>
            <p>sooner or later there is no one out there who's not</p>
            <p>half-made by the world.</p>
        </div>
    );
};
